import React, { Component } from 'react';
import { formatToINR } from 'Utils/transform';

export const RFQFTLTripsTable = ({lineItem}) => {
    const cities = lineItem.ftlStops.map((stop) => stop.city);
    return <div>
        <div className="flex flex-row flex-between">
            <span className="section-sub-header-color fBold fs-16">
                Trip
            </span>
            {!lineItem.hideCeilingPrice && <span className="section-sub-header-color fBold fs-16">
                {lineItem.totalPrice === undefined ? <span></span> :
                    <div>
                        <span className="fRegular fs-16 mr-5">Total Price </span> <span> {formatToINR(lineItem.totalPrice || 0)} </span>
                    </div>
                }             
            </span>}
        </div>
        <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Stops ({cities.length})
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5 pl-15">
                    Type
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Address
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Price
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Location Remarks
                </span>
            </div>
        </div>
        {
            lineItem.ftlStops.map((stop, index) => {
                return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {stop.location} {stop.pincode && ` - ${stop.pincode }`}
                        </span>
                    </div>
                    <div className="flex flex-1 col-3">
                        {lineItem.rfqServiceType !== 4 && <span className="section-sub-header-color  fs-14 pl-15">
                            {
                                stop.type === 1 && <span className="green-color"> Pickup </span>
                            }
                            {
                                stop.type === 2 && <span> Drop </span>
                            }
                            {
                                stop.type === 3 && (<div><span className="green-color"> Pickup </span><span>& Drop </span></div>)
                            }
                        </span>}
                            {lineItem.rfqServiceType === 4 && <span className="section-sub-header-color  fs-14 pl-15">
                            {
                                stop.type === 1 && index === 0 && <span className="green-color"> Pickup </span>
                            }
                            {
                                stop.type === 1 && index !== 0 && <span className="green-color"> Cargo Pickup </span>
                            }
                            {
                                stop.type === 2 && index === lineItem.ftlStops.length - 1 && <span> Drop </span>
                            }
                            {
                                stop.type === 2 && index !== lineItem.ftlStops.length - 1 && <span className="green-color"> Cargo Drop</span>
                            }
                            {
                                stop.type === 3 && (<div><span className="green-color"> Cargo Pickup </span><span>& Cargo Drop </span></div>)
                            }
                        </span>}
                    </div>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {stop.landmark}
                        </span>
                    </div>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            { (stop.additionalPrice && formatToINR(parseInt(stop.additionalPrice))) || 'NA' }
                        </span>
                    </div>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {stop.remarks ||  ''}
                        </span>
                    </div>
                </div>
            })
        }
    </div>
}